import $ from 'jquery';
let tpl = require('./speedometer.tpl.html');
import MeanOpinionScoreCalculator from "./MeanOpinionScoreCalculator";

const CHART_TYPE_SPEEDOMETER = 0;
const CHART_TYPE_SCORING = 1;

const SCORING_BAR_COUNT = 12;
const CONSTANT_BIT_RATE = "emodel_cbr";
const VARIABLE_BIT_RATE = "emodel_vbr";
const VARIABLE_BIT_RATE_PERC = "emodel_vbr_percent";
const DURATION = "emodel_duration";
const EMPTY_RESULT = "-";

/**
 * SpeedOMeterController
 */
class SpeedOMeterController {
    constructor($equalOneUIService, $timeout, $translate, $scope, $location, $anchorScroll) {
        this.equalOneUIService = $equalOneUIService;
        this.$timeout = $timeout;
        this.$translate = $translate;
        this.$location = $location;
        this.$anchorScroll = $anchorScroll;
        this.$scope = $scope;

        this.coef = 1;
        this.chartType = CHART_TYPE_SPEEDOMETER;
        this.currentScript;
        this.init();

        this.directionText = "";
        this.testStatus = 'stopped';
        this.currentResult = null;

        this.commandButtonLabel = "";
        this.meanOpinionScoreCalculator = null;

        this.scriptSelectionStatus = true;

        this.stepCount = 0;
        this.registeredTimeout = 1;

        this.chartWidth = !$("div#speedometerchart").width() || $("div#speedometerchart").width()<0?0:$("div#speedometerchart").width() - 1;
        this.chartHeight = !$("div#speedometerchart").height() || $("div#speedometerchart").height()<0?0:$("div#speedometerchart").height() - 1;

        this.scoringChartIsFaded = true;
        this.scoringTestType = "";

        this.module = 0;

        this.enabled = $equalOneUIService.enabled;
        if (this.enabled.speedometer) {
            this.scripts = this.equalOneUIService.getScripts();
            this.selectScript(this.scripts[0]);
        }
        $scope.$watch(
          () => this.equalOneUIService.enabled.speedometer, (newValue, oldValue) => {
            this.scripts = this.equalOneUIService.getScripts();
            if (this.scripts && this.scripts.length>0) {
                this.selectScript(this.scripts[0]);
            }
        }, true);

        var self = this;
        $(window).resize(function () {
            self.safeDrawChart(true);
        });


    }

    /**
     * Prepares some default value and UI elements
     */
    init() {
        this.minThroughput = 0.5;
        this.maxThroughput = 1000;

        this.instantThroughput = 0;
        this.timeoutProgress = 0;
        this.scoringInChartValues = [];
        for (let i = 0 ; i < SCORING_BAR_COUNT ; i++) {
            this.scoringInChartValues.push(0);
        }
    }

    updateChartConfig(service, scenarioChanged = false) {
        var self = this;
        self.init();
        if (service > 3) {
            self.chartType = CHART_TYPE_SCORING;
            self.hc = Highcharts.chart('chart1', self.getConfigScoring().options);
            self.ihc = Highcharts.chart('inChart', self.getConfigInChartScoring().options);
            if (scenarioChanged) {
                self.displayDirection(this.tr("app.speedometer.scoring"));
            }

            self.scoringChartIsFaded = false;


            switch (self.module) {
                case 1:
                    self.scoringTestType = this.tr("scoring.custom");
                    break;
                case 2:
                    self.scoringTestType = this.tr("scoring.voip");
                    break;

                case 3:
                    self.scoringTestType = this.tr("scoring.network");
                    break;
                case 4:
                    self.scoringTestType = this.tr("scoring.videoStreaming");
                    break;
                case 5:
                    self.scoringTestType = this.tr("scoring.tvLive");
                    break;
                case 6:
                    self.scoringTestType = this.tr("scoring.web");
                    break;

                default:
                    self.scoringTestType = "";
                    break;
            }

        } else {
            self.chartType = CHART_TYPE_SPEEDOMETER;
            self.hc = Highcharts.chart('chart1', self.getConfig().options);
        }

        this.$timeout(function() {
            self.drawChart(self, true);
            self.statusFontSize = 32 * self.coef;
        }, 0);
    }

    /**
     * Returns the configuration for the highchart-ng gauge aka speedometer
     * @returns {{options: {exporting: {enabled: boolean}, credits: {enabled: boolean}, chart: {type: string, plotBackgroundColor: null, plotBackgroundImage: null, plotBorderWidth: number, plotShadow: boolean}, title: {text: string}, pane: {startAngle: number, endAngle: number, background: *[]}, yAxis: *[], plotOptions: {gauge: {dial: {radius: string, backgroundColor: string, borderColor: string, borderWidth: number, baseWidth: number, topWidth: number, baseLength: string, rearLength: string}, pivot: {radius: number}, dataLabels: {align: string, y: number, borderWidth: number, style: {color: string, fontSize: string, fontWeight: string}, shadow: boolean, formatter: options.plotOptions.gauge.dataLabels.formatter}}}, tooltip: {enabled: boolean}, series: *[]}, series: *[], title: {text: string, verticalAlign: string}, loading: boolean, useHighStocks: boolean, func: (function(*))}}
     */
    getConfig() {
        var self = this;
        return {
            options: {
                exporting: {
                    enabled: false
                },
                credits: {
                    enabled: false
                },
                //This is the Main Highcharts chart config. Any Highchart options are valid here.
                //will be overriden by values specified below.
                chart: {
                    type: 'gauge',
                    plotBackgroundColor: null,
                    plotBackgroundImage: null,
                    plotBorderWidth: 0,
                    plotShadow: false,
                    width:this.chartWidth,
                    height:this.chartHeight
                },
                title: {
                    text: null
                },
                // contains the digits
                pane: {
                    startAngle: -135,
                    endAngle: 135,
                    background: [{
                        backgroundColor: '#363636',
                        borderWidth: 0,
                        outerRadius: '120%'
                    }, {
                        backgroundColor: '#fff'
                    }]
                },
                // the value axis
                yAxis: [{
                    id:"myAxisId",
                    min: 0.5,
                    max: 1000,
                    type: 'logarithmic',

                    lineWidth: 0,

                    minorTickInterval: null,
                    // HRI 3
                    tickWidth: 2,
                    // HRI 25
                    tickLength: 20,
                    tickColor: '#fff',
                    labels: {
                        // HRI 29
                        distance: 24,
                        step: 1,
                        rotation: 0,
                        // HRI font size 14px
                        style: {"color":"#fff","fontWeight":"bold","fontSize":"11px"},
                    },
                    // Mbps
                    title: {
                        text: 'Mbps',
                        // HRI font size 32px
                        style: {"color":"#212121", "fontSize":"26px","fontWeight":"bold"},
                        // HRI 70
                        y: 58
                    },
                    plotBands: [{
                        from: 0,
                        to: 1.1,
                        color: {
                            linearGradient: { x1: 0, y1: 0, x2: 1, y2: 0 },
                            stops: [
                                [0, '#673ab7'],
                                [1, '#673ab7']
                            ]
                        },
                        thickness: '10%'
                    }, {
                        from: 1,
                        to: 4.1,
                        color: {
                            linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 },
                            stops: [
                                [0, '#673ab7'],
                                [1, '#2196f3']
                            ]
                        },
                        thickness: '10%'
                    }, {
                        from: 4,
                        to: 20.1,
                        color: {
                            linearGradient: { x1: 0, y1: 1, x2: 0, y2: 0 },
                            stops: [
                                [0, '#2196f3'],
                                [1, '#4caf50']
                            ]
                        },
                        thickness: '10%'
                    }, {
                        from: 20,
                        to: 100.1,
                        color: {
                            linearGradient: { x1: 0, y1: 0, x2: 1, y2: 0 },
                            stops: [
                                [0, '#4caf50'],
                                [1, '#ffeb3b']
                            ]
                        },
                        thickness: '10%'
                    }, {
                        from: 100,
                        to: 405,
                        color: {
                            linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
                            stops: [
                                [0, '#ffeb3b'],
                                [1, '#ff5722']
                            ]
                        },
                        thickness: '10%'
                    }, {
                        from: 400,
                        to: 1000,
                        color:{
                            linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
                            stops: [
                                [0, '#ff5722'],
                                [1, '#f44336']
                            ]
                        },
                        thickness: '10%'
                    }],

                },{
                    lineWidth: 0,
                    min: 0,
                    max: 1000,
                    labels: {
                        enabled: false,
                    },
                    tickPixelInterval: 0,
                    plotBands: [{
                        from: 0,
                        to: 1000,
                        color: '#ffffff',
                        innerRadius: '78%',
                        outerRadius: '88%'
                    }],
                }],

                plotOptions: {
                    gauge: {
                        dial: {
                            radius: '102%',
                            backgroundColor: '#cdcdcd',
                            borderColor: '#363636',
                            borderWidth: 2,
                            baseWidth: 6,
                            topWidth: 6,
                            baseLength: '90%', // of radius
                            rearLength: '-70%'
                        },
                        pivot: {
                            radius: 0
                        },
                        dataLabels: {
                            align: "center",
                            // HRI 150
                            y: -124,
                            borderWidth: 0,
                            // HRI fontSize 64px
                            style: {"color":"#212121", "fontSize":"53px","fontWeight":"bold", "fontFamily": "Roboto"},
                            shadow: false,
                            formatter: function () {
                                return '';
                            }
                        }
                    },
                      series: {
                        animation: true
                      }
                },

                tooltip: {
                    enabled: false
                },

                series: [{
                    name: 'Speed',
                    data: [0.5],
                }]
            },
            //The below properties are watched separately for changes.

            //Series object (optional) - a list of series using normal Highcharts series options.
            series: [{
                data: [this.minThroughput]
            }],
            //Title configuration (optional)
            title: {
                text: '',
                verticalAlign: 'center'
            },
            //Boolean to control showing loading status on chart (optional)
            //Could be a string if you want to show specific loading text.
            loading: false,
            //Whether to use Highstocks instead of Highcharts (optional). Defaults to false.
            useHighStocks: false,
            //size (optional) if left out the chart will default to size of the div or something sensible.

            //function (optional)
            func(chart) {
                self.$timeout(function() {
                    self.drawChart(self, true);
                }, 0);
            }
        };
    }

    getConfigScoring() {
        var self = this;
        return {
            options: {
                exporting: {
                    enabled: false
                },
                credits: {
                    enabled: false
                },
                //This is the Main Highcharts chart config. Any Highchart options are valid here.
                //will be overriden by values specified below.
                chart: {
                    type: 'solidgauge',
                    animation: {
                        duration:self.registeredTimeout,
                        easing: 'linear'
                    },
                    width:this.chartWidth,
                    height:this.chartHeight
                },
                plotOptions: {
                    solidgauge: {
                        dataLabels: {
                            enabled: false
                        },
                        linecap: 'round',
                        stickyTracking: false,
                        rounded: true
                    }
                },
                title: {
                    text: null
                },
                // contains the digits
                pane: {
                    startAngle: 0,
                    endAngle: 360,
                    background: [{ // Track for Move
                        outerRadius: '105%',
                        innerRadius: '95%',
                        backgroundColor: "#dedede",
                        borderWidth: 0
                    }]
                },
                // the value axis
                yAxis: {
                    min: 0,
                    max: 100,
                    lineWidth: 0,
                    tickPositions: []
                },
                tooltip: {
                    enabled: false
                },
                series: [{
                        name: 'Score',
                        data: [{
                            color: '#426bba',
                            radius: '105%',
                            innerRadius: '95%',
                            y: 0
                        }]
                    }]
            },
            //The below properties are watched separately for changes.

            //Series object (optional) - a list of series using normal Highcharts series options.
            series: [{
                data: [this.timeoutProgress]
            }],
            //Title configuration (optional)
            title: {
                text: '',
                verticalAlign: 'center'
            },
            //Boolean to control showing loading status on chart (optional)
            //Could be a string if you want to show specific loading text.
            loading: false,
            //Whether to use Highstocks instead of Highcharts (optional). Defaults to false.
            useHighStocks: false,
            //size (optional) if left out the chart will default to size of the div or something sensible.

            //function (optionatil)
            func(chart) {
                self.$timeout(function() {
                    self.drawChart(self, true);
                }, 0);
            }
        };
    }

    getConfigInChartScoring() {
        var self = this;
        return {
            options: {
                exporting: {
                    enabled: false
                },
                credits: {
                    enabled: false
                },
                chart: {
                    type: 'column',
                    height:'75%',
                    backgroundColor:'rgba(255, 255, 255, 0)'
                },
                title: {
                    text: null
                },
                tooltip: {
                    enabled: false
                },
                plotOptions: {
                    column:{
                        color: '#426bba',
                        showInLegend:false
                    }
                },
                xAxis: {
                    lineWidth: 0,
                    minorGridLineWidth: 0,
                    labels: {
                        enabled: false
                    },
                    minorTickLength: 0,
                    tickLength: 0
                },
                yAxis: {
                    lineWidth: 0,
                    minorGridLineWidth: 0,
                    labels: {
                        enabled: false
                    },
                    title: {
                        text:null
                    },
                    minorTickLength: 0,
                    tickLength: 0,
                    visible:false
                },
                series: [{
                    data: this.scoringInChartValues
                }]
            },
            //The below properties are watched separately for changes.

            //Series object (optional) - a list of series using normal Highcharts series options.
            series: [{
                data: this.scoringInChartValues
            }],
            //Title configuration (optional)
            title: {
                text: '',
                verticalAlign: 'center'
            },
            //Boolean to control showing loading status on chart (optional)
            //Could be a string if you want to show specific loading text.
            loading: false,
            //Whether to use Highstocks instead of Highcharts (optional). Defaults to false.
            useHighStocks: false,
            //size (optional) if left out the chart will default to size of the div or something sensible.

            //function (optionatil)
            func(chart) {
                self.$timeout(function() {
                    self.drawChart(self, true);
                }, 0);
            }
        };
    }

    /**
     * Draws the charts into an angular context
     * @param resize True if size has changed, false otherwise
     */
    safeDrawChart(resize, scoringUpdate = false) {
        var self = this;
        this.$timeout(function() {
            self.drawChart(self, resize, scoringUpdate);
        }, 0);
    }

    /**
     * Draws the charts
     * @param self The SpeedOMeterController
     * @param resize True if size has changed, false otherwise
     * @param scoringUpdate True if scoring animation ring should start
     */
    drawChart(self, resize, scoringUpdate = false) {
        var containerElement = $("div#speedometerchart");
        var highchart = self.hc;//self.chartConfig.getHighcharts();//options;
        var yAxis = highchart.yAxis[0];
        const ratioConstant = 600.0;

        if (self.chartType === CHART_TYPE_SPEEDOMETER) {
            self.coef = containerElement.width() / ratioConstant;

            var coef = self.coef;

            yAxis.setTitle({
                style: {
                    fontSize: Math.round(32 * coef) + "px",
                },
                y: Math.round(75 * coef),
                text: '<div style="text-align:center;"><span style="font-size:' + Math.round(64 * coef) + 'px;font-family: Roboto">'
                + self.instantThroughput.toFixed(2) + '</span>'
                + '</div><br />Mbps'
            });

            if (!resize) {
                //make sure speed is between min and max of charts, else highcharts goes weird
                let speedValue =  Math.max(self.instantThroughput, self.minThroughput);
                speedValue = Math.min(speedValue, self.maxThroughput);
                highchart.series[0].data[0].update(speedValue);
                yAxis.isDirty = true;
                highchart.redraw({duration: 600, easing:'linear'});
            } else {
                self.toggleCommandButton();

                yAxis.update({
                    tickWidth: Math.round(coef * 3),
                    tickLength: Math.round(coef * 25.0),
                    labels: {
                        distance: Math.round(29.0 * coef),
                        style: {
                            fontSize: Math.round(coef * 14.0) + "px"
                        }
                    }
                });

                $('#line').remove();
                highchart.renderer.rect(160 * self.coef, 319 * self.coef, 280 * coef, 2, 1)
                    .attr({
                        'stroke-width': 1,
                        stroke: '#363636',
                        fill: '#363636',
                        zIndex: 3,
                        id: 'line'
                    })
                    .add();

                if (this.chartWidth != containerElement.width() && this.chartHeight != containerElement.width()) {
                    var chart = this.chartConfig;
                    try {
                        // Disabling animation before resizing for smoother experience
                        self.hc.animation = false;
                        self.hc.setSize(containerElement.width(), containerElement.width(), {duration:200}); // Short animation when resizing chart

                        self.hc.animation = true;
                        //chart.getHighcharts().animation = true;
                    } catch (e) {
                        console.log(e);
                    }

                    this.chartWidth = containerElement.width();
                    this.chartHeight = containerElement.width();
                }
            }

        } else if (self.chartType === CHART_TYPE_SCORING) {
            // ********************** Scoring

            self.coef = containerElement.width() / ratioConstant;
            var coef = self.coef;

            if (!resize) {
                if (scoringUpdate) {
                    highchart.series[0].data[0].update(self.timeoutProgress);

                    yAxis.isDirty = true;
                    highchart.redraw({duration:self.registeredTimeout, easing:'linear'});
                }


                self.ihc.series[0].update({data:self.scoringInChartValues}, true);

            } else {
                self.toggleCommandButton();

                if (this.chartWidth != containerElement.width() && this.chartHeight != containerElement.width()) {
                    var chart = this.chartConfig;
                    try {
                        // Disabling animation before resizing for smoother experience
                        self.hc.animation = false;
                        self.hc.setSize(containerElement.width(), containerElement.width(), {duration:200}); // Short animation when resizing chart

                        $('#line').remove();

                        self.hc.animation = true;
                    } catch (e) {
                        console.log(e);
                    }

                    this.chartWidth = containerElement.width();
                    this.chartHeight = containerElement.width();
                }
            }
        }
    }

    /**
    * Display the button according to the test status (START if stopped, STOP if started)
    */
    toggleCommandButton() {
        if (this.testStatus == 'stopped') {
            this.commandButtonLabel = this.tr("app.speedometer.start");
        } else {
            this.commandButtonLabel = this.tr("app.speedometer.stop");
        }
    }

    onCommandButtonClicked() {
        if (this.testStatus == 'stopped') {
            this.start();
        } else {
            this.stop();
        }
    }

    setRcaLabel(rcaCode) {
        let rcaLabel = this.tr("kpi.label.rca1.unknown");
        if (rcaCode.toString() === "100") {
            rcaLabel = this.tr("kpi.label.rca1.device");
        } else if (rcaCode.toString() === "200") {
            rcaLabel = this.tr("kpi.label.rca1.lastmile.congestion");
        } else if (rcaCode.toString() === "300") {
            rcaLabel = this.tr("kpi.label.rca1.core.backhaul");
        } else if (rcaCode.toString() === "500") {
            rcaLabel = this.tr("kpi.label.rca1.server");
        } else if (rcaCode.toString() === "900") {
            rcaLabel = this.tr("kpi.label.rca1.multiple");
        }

        return rcaLabel;
    }

    /**
     * Start the test using the selected script
     */
    start() {
        this.disableScriptSelection();
        let socketCount = 0;
        this.equalOneUIService.startScript(this.currentScript.key, (step, index, data) => {
            if (step === 'SCRIPT_STARTED') {
                this.stepCount = 0;
            } else if (step === 'STEP_PROGRESS' ) {
                if (data.type === 'pause') {
                    this.direction = "pause";
                    this.displayDirection(this.tr("app.speedometer.pause") + " " + data.remaining);
                    this.safeDrawChart(false);
                    this.currentResult = null;
                } else if (data.type === 'mscore') {
                    //this.timeoutProgress = (data.sessionTime * 100) / data.timeout;
                    //special case if instantTime is very low (normally shoudl be 500ms), we skip the update
                    if (data.instantTime>=200) {
                      this.instantThroughput = (data.instantBytes * 8 / 1000000) / (data.instantTime / 1000);
                    }
                    if (isNaN(this.instantThroughput) ||this.instantThroughput == Infinity) {
                        this.instantThroughput = 0;
                    }
                    this.direction = data.direction;

                    if (this.chartType === CHART_TYPE_SCORING) {
                        if (this.scoringInChartValues.length >= SCORING_BAR_COUNT) {
                            this.scoringInChartValues.shift();
                        }
                        if (this.meanOpinionScoreCalculator) {
                            const calculatedMos = this.meanOpinionScoreCalculator.add(this.instantThroughput*1000);
                            this.scoringInChartValues.push({y:calculatedMos, color: this.colorForCalculatedMos(calculatedMos)});
                        } else {
                            // If not enough parameters, use throughput
                            this.scoringInChartValues.push(this.instantThroughput);
                        }
                    }



                    this.safeDrawChart(false);
                } else {
                    //console.log('UNHANDLED TYPE');
                }
            } else if (step === 'STEP_DONE') {
                if (data && data.type === "mscore") {
                    this.stepCount++;
                    this.timeoutProgress = 100;
                    this.currentResult.setTestType(parseInt(data.service));
                    this.currentResult.setModule(data.module);
                    this.currentResult.setScoringType(this.scoringTestType);

                    if (data.status === 'success' && data.computeFailed === false) {
                        this.currentResult.setStatus("SUCCESS");
                        this.currentResult.setStatusLabel(this.tr("app.results.success"));
                        this.displayDirection(this.tr("app.results.success"));
                        this.instantThroughput = data.maxThroughput / 1000;
                        this.currentResult.setThroughput(this.instantThroughput.toFixed(2));
                        var average = data.averageThroughput / 1000;
                        this.currentResult.setAverage(average.toFixed(1));
                        this.currentResult.setLatency(data.extras.RTT_AVG_MS);
                        this.currentResult.setRetrans(data.extras.RETRANS_PERCENT);
                        this.currentResult.setJitter(data.extras.JITTER_AVG_MS);
                        var threads = parseInt(data.extras['THREADS'], 10);
                        this.currentResult.setMinLatency(data.minLatency);
                        this.currentResult.setRca1(this.setRcaLabel(data.rootCauseAnalysis1));
                        if (data.chartUrl) {
                            this.currentResult.setChartLink(data.chartUrl);
                        }
                        this.currentResult.setChartLinkArray(socketCount);


                        this.currentResult.setMos((Math.round(data.mos*10)/10));
                        if (this.chartType === CHART_TYPE_SCORING && data.mos) {
                            this.displayDirection(this.currentResult.mos + "/5");
                        }

                    } else if (data.status === 'cancelled' || data.status === 'canceled') {
                        this.displayDirection(this.tr("app.results.cancelled"));
                        this.currentResult.setStatus("CANCELLED");
                        this.currentResult.setStatusLabel(this.tr("app.results.cancelled"));
                    } else {
                        this.displayDirection(this.tr("app.results.fail"));
                        this.currentResult.setStatus("FAILED");
                        this.currentResult.setStatusLabel(this.tr("app.results.fail"));

                        this.currentResult.setThroughput(EMPTY_RESULT);
                        this.currentResult.setAverage(EMPTY_RESULT);
                        this.currentResult.setLatency(EMPTY_RESULT);
                        this.currentResult.setRetrans(EMPTY_RESULT);
                        this.currentResult.setJitter(EMPTY_RESULT);
                        this.currentResult.setMinLatency(EMPTY_RESULT);
                        this.currentResult.setRca1(EMPTY_RESULT);
                        this.currentResult.setChartLink(null);
                    }

                    // Clear scoring animation
                    this.registeredTimeout = 1;
                    this.timeoutProgress = 100;
                    this.safeDrawChart(false, true);
                } else {
                    if (data.code === 10001) {
                        this.displayDirection(this.tr("app.results.cancelled"));
                        if (this.currentResult != null) {
                            this.currentResult.setStatus("CANCELLED");
                            this.currentResult.setStatusLabel(this.tr("app.results.cancelled"));
                        }
                    }
                }
            } else if (step === 'STEP_STARTED' && data.type === 'mscore') {
                if (data && data.module) {
                    this.module = data.module;
                } else {
                    this.module = 0;
                }

                if (data && data.socketCount) {
                    socketCount = data.socketCount;
                }


                this.updateChartConfig(data.service);

                this.meanOpinionScoreCalculator = null;

                if (this.chartType === CHART_TYPE_SPEEDOMETER) {
                    this.directionText = "";
                } else if (this.chartType === CHART_TYPE_SCORING) {
                    this.scoringChartIsFaded = false;
                    if (data && data.params[CONSTANT_BIT_RATE] && data.params[VARIABLE_BIT_RATE] && data.params[VARIABLE_BIT_RATE_PERC] && data.params[DURATION]) {
                        this.meanOpinionScoreCalculator = new MeanOpinionScoreCalculator(data.params[CONSTANT_BIT_RATE], data.params[VARIABLE_BIT_RATE], data.params[VARIABLE_BIT_RATE_PERC], data.params[DURATION]);
                    }
                }

                // Animate
                var self = this;
                window.setTimeout(() => {
                    self.scoringChartIsFaded = true;
                }, 1000);


                this.direction = data.direction;
                this.currentResult = this.equalOneUIService.startNewResult();
                this.currentResult.setInfo(this.currentScript.label);
                this.currentResult.setModule(this.module);

                //TODO: Set the direction here, when the SDK will permit it.
                this.direction = data.direction;
                if (this.chartType == CHART_TYPE_SPEEDOMETER) {
                    if (data.direction === 'download') {
                        this.currentResult.setStatus("DOWNLOADING");
                        this.currentResult.setStatusLabel(this.tr("app.results.downloading"));
                        this.currentResult.setDirection("DOWNLOAD");
                        if (this.chartType === CHART_TYPE_SPEEDOMETER) {
                            this.displayDirection(this.tr("app.speedometer.download"));
                        }
                        this.safeDrawChart(false);
                    } else {
                        if (data.direction === 'upload') {
                            this.currentResult.setStatus("UPLOADING");
                            this.currentResult.setStatusLabel(this.tr("app.results.uploading"));
                            this.currentResult.setDirection("UPLOAD");
                            if (this.chartType === CHART_TYPE_SPEEDOMETER) {
                                this.displayDirection(this.tr("app.speedometer.upload"));
                            }
                            this.safeDrawChart(false);
                        }
                    }
                } else if (this.chartType == CHART_TYPE_SCORING) {
                    // Prepare chart
                    this.registeredTimeout = 1;
                    this.timeoutProgress = 0;
                    this.safeDrawChart(false, true);

                    this.registeredTimeout = data.timeout;
                    this.timeoutProgress = 100;
                    this.displayDirection(this.tr("app.speedometer.scoring"));
                    this.currentResult.setStatusLabel(this.tr("app.results.scoring"));
                }

                this.testStatus = 'started';
                this.toggleCommandButton();
                this.safeDrawChart(false, true);
            } else if (step === 'STEP_STARTED' && data.type === 'pause') {
                this.toggleCommandButton();
            } else if (step == 'SCRIPT_DONE') {
                this.direction = "";
                this.testStatus = 'stopped';
                this.toggleCommandButton();
                this.enableScriptSelection();


                //scroll to results once script is done
                //this scrolls to result panel
                this.$location.hash('results');
                this.$anchorScroll();
            }
        });
    }

    colorForCalculatedMos(mos) {
        if (mos < 1) {
            return "#8AA3D6";
        }  else if (mos < 2) {
            return "#7795CF";
        }  else if (mos < 3) {
            return "#6486C9";
        }  else if (mos < 4) {
            return "#5177C2";
        } else {
            return "#426bba";
        }
    }

    /**
     * Switch UI to first step test
     */
    switchToFirstStep() {
        // Set back default UI
        if (this.currentScript && this.currentScript.steps && this.currentScript.steps.length > 0) {
            this.module = this.currentScript.steps[0].module?this.currentScript.steps[0].module:0;
            this.updateChartConfig(this.currentScript.steps[0].service, true);
        }
    }

    /**
     * Stops the current test
     */
    stop() {
        this.equalOneUIService.stopScript(this.currentScript.key);

        // Reinit scoring chart
        if (this.chartType === CHART_TYPE_SCORING) {
            this.registeredTimeout = 1;
            this.timeoutProgress = 0;
            this.safeDrawChart(false, true);
        }

        this.switchToFirstStep();
    }

    /**
     * Selects the script to play
     * @param scenarioScript
     */
    selectScript(scenarioScript) {
        this.displayDirection("");
        if (scenarioScript == null) {
            this.equalOneUIService.setCurrentScript(undefined);
            return;
        }
        this.currentScript = scenarioScript;
        this.equalOneUIService.setCurrentScript(this.currentScript);

        this.scripts.forEach((s) => {
            s.isSelected = false;
        });
        scenarioScript.isSelected = true;

        this.switchToFirstStep();
    }

    /**
     * Display the test status on the gauge
     * @param directionText
     */
    displayDirection(directionText) {
        this.statusFontSize = 32 * this.coef;
        this.directionText = directionText;
    }

    /**
     * Disable the scripts buttons
     */
    disableScriptSelection() {
        var self = this;
        this.scriptSelectionStatus = false;
        this.$timeout(function() {
            self.scripts.forEach((s) => {
                s.isDisabled = true;
            });
        });
    }

    /**
     * Enable the scrips buttons
     */
    enableScriptSelection() {
        var self = this;
        this.scriptSelectionStatus = true;
        this.$timeout(function() {
            self.scripts.forEach((s) => {
                s.isDisabled = false;
            });
        });
    }

    tr(key) {
        return this.$translate.instant(key);
    }
}

SpeedOMeterController.$inject = ['EQualOneUIService', '$timeout', '$translate', '$scope', '$location', '$anchorScroll'];

let SpeedOMeter = {
    bindings: {
        mytitle: "@"
    },
    templateUrl: tpl,
    controller: SpeedOMeterController
};

export default SpeedOMeter;


// WEBPACK FOOTER //
// ./src/equalone-ui/components/speedometer/speedometer.component.js